// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1MKAE","alertIcon":"ConfirmModal_alertIcon__3ZVZk"};